
export enum CngTanksMaterials {
  Steel= 'Steel',
  Aluminum= 'Aluminum',
  Composite= 'Composite',

}